exports.setCookie = (key, val, domain, path = '/') => { document.cookie = `${key}=${val};domain=${domain};path=${path};`; };

exports.deleteCookie = (key, domain, path = '/') => { document.cookie = `${key}=;domain=${domain};path=${path};expires=Thu, 01 Jan 1999 00:00:00 GMT`; };



// WEBPACK FOOTER //
// ./src/helpers/cookie.js